import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import InputFilter from '../InputFilter'
import { FaFilter } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';

import { RequestsContext } from '../../context/requests'


import ReactLoading from 'react-loading';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale"; // Importa o locale em pt-BR
registerLocale("pt-BR", ptBR);


const CardWrapper = styled.section`
    display:flex;
    justify-content: space-between;

    #dropdown-basic{
    width: 142px;
    height: 43px;
    border: none;
    font-family: "Poppins";
    font-weight: 500;
    color: white;
    background-color: rgba(0,0,0,.774);
    border-radius: 50px;
    }


    @media screen and (max-width:720px){
        flex-direction: column;
        width: 100%;

        input{
            width: 100%;
        }

    #dropdown-basic{
    margin-top: 1.3rem;
    width: 100%;
    height: 43px;
    border: none;
    font-family: "Poppins";
    font-weight: 500;
    color: white;
    background-color: rgba(0,0,0,.774);
    border-radius: 50px;
    }
    }

`
const Button = styled.button`
    width: 100%;
    height: 34px;
    border: none;
    font-family: "Poppins";
    font-weight: 500;
    color: white;
    font-size: 0.9rem;
    background-color: rgba(0,0,0,.774);
    border-radius: 50px;

`
const ButtonAdd = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 143px;
    height: 43px;
    border: none;
    font-family: "Poppins";
    font-weight: 600;
    color: white;
    font-size: 0.9rem;
    background-color: rgba(0,0,0,.774);
    border-radius: 50px;

    @media screen and (max-width:720px){
        margin: 1.2rem auto;
        width: 90%;
    }

`
const Filter = ({ buttonName, type,onClick,onChange,onBlur,animation,selectItems,btn,placeholder}) => {

       const {
        getByDate
        } = useContext(RequestsContext)
    
    const [selectedDate, setSelectedDate] = useState(null); // Armazena a data selecionada


    return (

        <CardWrapper>
            <InputFilter placeholder={placeholder} onChange={onChange}  onBlur={onBlur}/>
            {type == 3 
            
            ?
            
            <Dropdown>
                <Dropdown.Toggle  id="dropdown-basic">
                    {buttonName} {type == 3 ? <FaFilter /> : <></>}
                </Dropdown.Toggle>
            
                    <Dropdown.Menu>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => {setSelectedDate(date);}}
                            inline // Exibe o calendário aberto
                            locale={'pt-BR'}

                        />
                        <Button onClick={() => getByDate(selectedDate)}>Filtrar</Button>
                    </Dropdown.Menu>
                

            </Dropdown>     
            :

            btn == false 
            
            ?
            <></>
            :

            <ButtonAdd onClick={onClick}>{animation == true ?                                    
            <ReactLoading type={"bars"} color={"white"}  height={25} width={25}  />
            : 
            buttonName
            }</ButtonAdd>

            }
   

        </CardWrapper>

    )
}

export default Filter